import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const twins: Array<ItemVM> = [
  {
    id: 2,
    value: '2',
  },
  {
    id: 3,
    value: '3',
  },
  {
    id: 4,
    value: '4',
  },
  {
    id: 5,
    value: '5',
  },
  {
    id: 6,
    value: '6',
  },
  {
    id: 7,
    value: '7',
  },
  {
    id: 8,
    value: '8',
  },
  {
    id: 9,
    value: '9',
  },
  {
    id: 10,
    value: '10',
  },
];

interface ListTwinsProps {
  disabled?: boolean;
  required?: boolean;
  value: number;
  onChange: (event: SelectChangeEvent<number>) => void;
  error?: boolean;
  isSmallSize?: boolean;
}

const ListTwinsComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
}: ListTwinsProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="twin-label">
        {required ? 'Numero gemelli *' : 'Numero gemelli'}
      </InputLabel>
      <PmiSelect
        labelId="twin-label"
        id="twin"
        name="twin"
        value={value}
        label={required ? 'Numero gemelli *' : 'Numero gemelli'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {twins.map((twin: ItemVM) => (
          <MenuItem key={twin.id} value={twin.id}>
            {twin.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTwinsComponent.displayName = 'List Twins component';

const ListTwins = memo(ListTwinsComponent);

export default ListTwins as typeof ListTwinsComponent;
